import { render, staticRenderFns } from "./Brance.vue?vue&type=template&id=60a28b47"
import script from "./Brance.vue?vue&type=script&lang=js"
export * from "./Brance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports